import React, { useEffect, useState } from "react";
import styled from "styled-components";
import classnames from "classnames";

export interface IInputProps {
    id: string | number;
    label: string;
    hasValue: boolean;
    className?: string;
    children;
    error?: string;
    labelClassName?: string;
    errorClassName?: string;
    darkBg?: boolean;
}

export default styled((props: IInputProps) => {
    const { id, label, hasValue, className, children, error, labelClassName, errorClassName = "text-primary", darkBg } = props;
    const [showHasValue, setShowHasValue] = useState(false);
    // force gatsby hydrate refresh hasValue in UI with useEffect
    useEffect(() => {
        setShowHasValue(hasValue);
    }, [hasValue]);
    return (
        <div className={classnames("form-group", className)}>
            <div className={classnames({ "has-value": showHasValue, "dark-bg": darkBg })}>
                {error && <div className={classnames("error", errorClassName)}>{error}</div>}
                {children}
                {label &&
                    <label className={classnames("label", "font-weight-normal", labelClassName)} htmlFor={String(id)}>{label}</label>
                }
            </div>
        </div>
    );
})`
    position: relative;

    .dark-bg input {
        background-color: ${props => props.theme.gray250};
        border: none;
    }
    .form-control {
        height: auto;
    }

    input.has-label {
        padding-top: 1.4rem;
    }

    label {
        position: absolute;
        top: 0;
        z-index: 100;
        padding-top: 1rem;
        padding-left: 1rem;
        font-size: 16px;
        pointer-events: none;
        transition: padding .1s ease, font-size .1s ease;
        color: var(--mud, #5E514D);
    }

    input:focus+label, .has-value label {
        font-size: 12px;
        padding-top: .1rem !important;
        padding-left: .5rem;
    }

    .error {
        position: absolute;
        bottom: -1.2rem;
        left: 1rem;
        font-size: .8rem;
    }
`;